import { render, staticRenderFns } from "./RequisitionDimension.vue?vue&type=template&id=223e0885"
import script from "./RequisitionDimension.vue?vue&type=script&lang=js"
export * from "./RequisitionDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports